import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE } from '../styles/typography/typography';
import { PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_TEXT_HEADER } from '../styles/colors/colors';
export var SelectGroupItem = styled(MenuItem)({
  '&.MuiMenuItem-root': _objectSpread(_objectSpread({
    margin: 0,
    userSelect: 'none',
    pointerEvents: 'none',
    display: 'block',
    flexShrink: 0
  }, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE), {}, {
    height: 29,
    marginTop: 2,
    marginRight: 16,
    marginBottom: 2,
    marginLeft: 16,
    paddingTop: 9,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    color: PROMETHEAN_TEXT_HEADER,
    opacity: 1,
    borderBottom: '1px solid ' + PROMETHEAN_NEUTRAL_DARK_GREY,
    '&.SelectGroupItem-fullSize': {
      height: 'auto',
      minHeight: 29,
      wordBreak: 'break-word',
      whiteSpace: 'normal'
    }
  })
});